import { Alert, AlertDescription, AlertIcon, AlertTitle, Box } from '@chakra-ui/react';
import React from 'react';

const AuthorisationDeniedWarning: React.FC = () => (
  <Alert status="error" mb="4">
    <AlertIcon />
    <Box>
      <AlertTitle>Agent authorisation denied by applicant</AlertTitle>
      <AlertDescription>{'This application has been closed'}</AlertDescription>
    </Box>
  </Alert>
);

export default AuthorisationDeniedWarning;
